import { useEffect, useState } from "react";
import { Reveal } from "@/lib/motion";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Client quotes managed from /admin. Renders nothing until at least one is published —
// no placeholder or invented testimonials ever appear on the site.
export const Testimonials = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    fetch(`${API}/testimonials`).then((r) => r.json()).then((d) => Array.isArray(d) && setItems(d)).catch(() => {});
  }, []);

  if (items.length === 0) return null;
  return (
    <section data-testid="testimonials-section" className="bg-cream pb-28">
      <div className="max-w-[1300px] mx-auto px-6 lg:px-10">
        <Reveal>
          <p className="font-mono text-[12px] uppercase tracking-[0.28em] text-[#8a6b2f] mb-5">From our clients</p>
          <h2 className="font-serif text-4xl lg:text-5xl text-navy tracking-tight leading-tight max-w-2xl">
            In their words
          </h2>
        </Reveal>

        <div className="mt-14 grid md:grid-cols-2 gap-x-14 gap-y-12 border-t border-[#D9CFB8] pt-12">
          {items.map((t, i) => (
            <Reveal key={t.id} delay={i * 0.08}>
              <figure data-testid="testimonial-item" className="relative pl-8">
                <span aria-hidden="true" className="absolute left-0 -top-3 font-serif text-5xl leading-none text-gold/70">“</span>
                <blockquote className="font-serif text-2xl lg:text-[1.7rem] text-navy leading-snug">{t.quote}</blockquote>
                <figcaption className="mt-5 font-mono text-[11px] uppercase tracking-[0.2em] text-ink-muted">
                  <span className="text-navy">{t.author}</span>{t.business && <> · {t.business}</>}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
